import { ProjectForm, type LeadDefaults } from '@/components/features/Projects/forms/ProjectForm';
import type { LeadOption } from '@/components/global/LeadSelect';
import type { PersonOption } from '@/components/global/PersonSelect';
import { useTranslations } from '@/hooks/useTranslations';
import CreateLayout from '@/layouts/create-layout';

interface ProjectCreateProps {
    /** Everyone who can own a project, commercially-responsible roles first. */
    ownerCandidates?: { people: PersonOption[]; suggested_ids: string[] };
    /** Leads that can be converted, for the optional picker in step one. */
    leadOptions?: LeadOption[];
    /** Present when opened as ?lead_id=… — the same form, prefilled. */
    initialLead?: LeadDefaults | null;
}

export default function ProjectCreate({ ownerCandidates, leadOptions = [], initialLead }: ProjectCreateProps) {
    const { t } = useTranslations();

    return (
        <CreateLayout
            breadcrumbs={[
                { title: t('projects.create.breadcrumbs.dashboard', 'Dashboard'), href: '/' },
                { title: t('projects.index.heading', 'Projects'), href: '/projects' },
                { title: t('projects.create.breadcrumbs.create', 'Create'), href: '#' },
            ]}
            title={t('projects.create.heading', 'Create Project')}
            subtitle={
                initialLead
                    ? t('projects.create.subheading_from_lead', 'Converting lead :lead — the lead will be marked as won.').replace(
                          ':lead',
                          initialLead.lead_number ?? '',
                      )
                    : t('projects.create.subheading', 'Create and manage projects')
            }
        >
            {/* Keyed on the lead: picking one re-fetches this page with its defaults, and
                the form only reads them when it mounts. */}
            <ProjectForm key={initialLead?.id ?? 'no-lead'} ownerCandidates={ownerCandidates} leadOptions={leadOptions} initialLead={initialLead} />
        </CreateLayout>
    );
}
